import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row wrap',
      gap: theme.spacing(0.5),
    },
    isSlim: {},
    hasLotsOfNonImages: {},

    attachmentImage: {},
    attachmentOther: {
      '$hasLotsOfNonImages &': {
        maxWidth: 105,
        '$isSlim &': {
          maxWidth: 60,
        },
      },
    },
  }),
  { name: 'Attachments' }
);
